/**
 * Server clock-offset tracker.
 *
 * The axios response interceptor reads the HTTP `Date` header on every successful
 * API response and stores the offset (browser time minus server time, in ms) here.
 * Components that render countdowns against server-produced timestamps (Delay /
 * Loop cooldowns, session timers) use `serverNow()` to get a browser-local millis
 * value that tracks the server's clock — so a user whose machine clock is drifted
 * still sees an accurate countdown to the moment the server will expire the delay.
 */

let serverClockOffsetMs = 0

export function setServerClockFromDateHeader(dateHeader: string | undefined | null): void {
  if (!dateHeader) return
  const parsed = Date.parse(dateHeader)
  if (Number.isNaN(parsed)) return
  // offset is "browser ahead of server" — positive when the browser clock is
  // running fast vs the server.
  serverClockOffsetMs = Date.now() - parsed
}

export function getServerClockOffsetMs(): number {
  return serverClockOffsetMs
}

/** A server-aligned "now" in milliseconds since epoch, usable for subtraction
 *  from server-provided ISO timestamps like cooldownEndsAt. */
export function serverNow(): number {
  return Date.now() - serverClockOffsetMs
}
